// import { combineReducers } from "redux";
// import userReducer from "./reducers/user";

// const rootReducer = combineReducers({
//     user: userReducer
// })

// export default rootReducer;


import { configureStore } from '@reduxjs/toolkit';
import userReducer from './reducers/user';
import listStateReducer from './reducers/listStateSlice';

const store = configureStore({
    reducer: {
        user: userReducer,
        listState: listStateReducer
    }
})

export default store;